import { Auth } from '@/AuthProvider';
import { DefaultQueryProvider } from '@zg-rentals/react-query5';
import { ToastProvider } from '@zillow/constellation-10';

export const AppProviders = ({ children }: { children: React.ReactNode }) => (
  <DefaultQueryProvider>
    <ToastProvider>
      <Auth.Provider>{children}</Auth.Provider>
    </ToastProvider>
  </DefaultQueryProvider>
);
